const DEFAULT_DURATION = 750;

function animate ($el, duration, callback) {
  const top = $el ? $el.offset().top : 0;
  duration = duration ? duration : DEFAULT_DURATION;

  if ($(document).height() - top > $(window).height()){
    $('html, body').animate( {
      scrollTop: top
    }, duration, 'swing', callback);
  }
  else{ // So the transition plays entirely
    $('html, body').animate( {
      scrollTop: $(document).height() - $(window).height()
    }, duration, 'swing', callback);
  }
}

function jump ($el) {
  const top = $el ? $el.offset().top : 0;
  window.scrollTo(0, top);
}

module.exports = {
  animate: animate,
  jump: jump
};